import script from "./UserRenewal.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRenewal.vue?vue&type=script&setup=true&lang=js"

import "./UserRenewal.vue?vue&type=style&index=0&id=c6fbfb98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6fbfb98"]])

export default __exports__